<template>
  <div>
    <div class="food_list">
      <div class="food_box" @click="todetail(index)" v-for="(item,index) in storeList">
        <div class="foodbox_left">
          <img class="food_img" :src="item.thumb" />
          <div class="food_des">{{item.name}}</div>
        </div>
        <img class="food_to" src="/static/xiangyou.png" />
      </div>
    </div>
<!--    <img src="/static/hagendasi.png" /> -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  export default {
    data() {
      return {
        storeList: [], //接口获取商品列表
      }
    },
    created() {
 if (this.$route.query.cate_id) {
        this.request("getstoreList", {
          cate_id: this.$route.query.cate_id
        })
      }
    },
    mounted() {

    },
    methods: {
      // todetail(e) {
      //   this.$router.push({
      //     path: "/foodDetail",
      //     query: {
      //       foodDetailId: e
      //     }
      //   })
      // },
      todetail(e) {

        this.$router.push({
          path: '/foodDetail',
          query: {
            id: this.storeList[Number(e)].id
          }
        })
      },
      //调接口封装
      request(type, requestData = {}) {
        let that = this
        switch (type) {
          //获取商品列表
          case 'getstoreList':
            httper.get('product/get-online-by-cate', requestData, res => {
              if (res.code === 0) {
                console.log("商品列表", res)
                this.storeList = res.data
              } else {
                this.$toast({
                  message: res.message
                })
              }
            })
            break
        }
      },
    }
  }
</script>

<style>
  .food_list {
    margin: 20px;
  }

  .food_box {
    width: 95%;
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border: 1px solid #dedede;
    margin-bottom: 20px;
    /* background-image: url(../../../static/aiqiyibanner.png); */
  }

  .foodbox_left {
    display: flex;
    align-items: center;
  }

  .food_img {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    margin: 10px;
  }

  .food_des {}

  .food_to {
    width: 35px;
    height: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/food/foodList.vue